// Color por ítem del drawer "Análisis de Categorías" (Rentabilidad): barras
// de las cards y líneas de la evolución. Una categoría tiene UN color en todo
// el drawer y dos categorías nunca comparten color en las cards (Steve,
// 2026-10-05): antes el color salía del puesto del ítem en el ranking de
// ventas con 5 colores en rueda, así que el sexto repetía al primero y una
// card de margen podía pintar otra tienda con el color de la de Ventas.
//
// El orden de asignación es el de aparición en las cards (Ventas primero, en
// su orden), así lo que se ve arriba toma los primeros colores; después, el
// resto de los ítems (sólo los dibuja la evolución). Con 4 cards de top 3 hay
// a lo más 12 ítems distintos: la paleta alcanza para que las cards nunca
// repitan. Más allá (la evolución con una docena larga de ítems) la rueda
// vuelve a empezar. Puro, sin Vue.

export const ITEM_COLOR_TOKENS = [
	"--progress-bar-1",
	"--progress-bar-2",
	"--progress-bar-3",
	"--progress-bar-4",
	"--progress-bar-5",
	"--progress-bar-6",
	"--progress-bar-7",
	"--progress-bar-8",
	"--progress-bar-9",
	"--progress-bar-10",
	"--progress-bar-11",
	"--progress-bar-12",
];

/**
 * Token de color (`--progress-bar-N`) por nombre de ítem.
 * @param {Array<{items?: Array<{name: string, is_rest?: boolean}>}>} cards
 * @param {string[]} items ítems del payload (orden del backend).
 * @returns {Object<string, string>}
 */
export function itemColorTokens(cards = [], items = []) {
	const order = [];
	const seen = new Set();
	const add = (name) => {
		if (name == null || seen.has(name)) return;
		seen.add(name);
		order.push(name);
	};
	cards.forEach((card) => (card.items || []).forEach((item) => {
		// "Otros" no es un ítem: tiene su neutro propio.
		if (!item.is_rest) add(item.name);
	}));
	items.forEach(add);
	return order.reduce((acc, name, i) => {
		acc[name] = ITEM_COLOR_TOKENS[i % ITEM_COLOR_TOKENS.length];
		return acc;
	}, {});
}
